import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

// A tab left open across a deploy holds an index.html referencing chunk hashes
// that no longer exist. Routes are lazy-loaded, so it keeps working until the
// user navigates somewhere new — then the chunk fetch fails (Netlify's SPA
// catch-all answers with index.html, so it surfaces as a MIME type error).
// Reload once to pick up the current build. The sessionStorage guard means a
// genuinely broken deploy shows the real error instead of reload-looping.
// Time-based rather than a simple flag: the reload itself loads index.html
// successfully (only the lazy chunk 404s), so any "clear on success" signal
// would rearm the guard and let a genuinely broken deploy loop forever.
const RELOAD_GUARD_KEY = 'chunk-reload-attempted-at';
const RELOAD_GUARD_WINDOW_MS = 30 * 1000;
window.addEventListener('vite:preloadError', (event) => {
  const lastAttempt = Number(sessionStorage.getItem(RELOAD_GUARD_KEY)) || 0;
  // Outside the window this is a fresh deploy, not the same failure repeating.
  if (Date.now() - lastAttempt < RELOAD_GUARD_WINDOW_MS) return;
  event.preventDefault();
  sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
  window.location.reload();
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
